var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popover',{attrs:{"popoverClass":['help-tooltip', { transparent: !_vm.question }],"placement":_vm.placement,"trigger":_vm.trigger,"container":_vm.container,"popperOptions":{
    modifiers: {
      flip: { enabled: false },
      hide: {
        enabled: false,
      },
      preventOverflow: { enabled: false },
    },
  },"open":_vm.isTooltip},on:{"show":function($event){_vm.isTooltip = true}}},[(_vm.question)?_c('span',{staticClass:"question"},[_vm._v("?")]):_vm._t("message",[_c('p',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.message))])]),_vm._v(" "),_c('div',{staticClass:"message",class:{ transparent: !_vm.question },attrs:{"slot":"popover"},slot:"popover"},[_c('span',[_vm._v(_vm._s(_vm.message))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }